// extracted by mini-css-extract-plugin
export var cancelButton = "_m4-5";
export var content = "_m4-3";
export var createButton = "_m4-6";
export var drawerContainer = "_m4-0";
export var footer = "_m4-2";
export var header = "_m4-1";
export var orderFormColumn = "_m4-4";